import {Divider, Grid, GridProps, Typography, makeStyles} from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';

export type GridRowItem = {
  key: string;
  element: React.ReactNode;
  props?: GridProps;
  hidden?: boolean;
};

export type GridRowProps = {
  items: GridRowItem[];
  rowProps?: GridProps;
  title?: string;
  hidden?: boolean;
};

const useGridRowStyles = makeStyles(() => ({
  gridRowContainer: {
    margin: '0.5rem 0',
    alignItems: 'center',
  },
}));

const defaultGridItemProps: GridProps = {xs: 12, sm: 12, md: 4};

export const GridRow = (props: GridRowProps) => {
  const {rowProps, items, title} = props;
  const classes = useGridRowStyles();
  return (
    <Grid container spacing={2} className={classNames(classes.gridRowContainer, rowProps?.className)}>
      {title && (
        <React.Fragment>
          <Typography variant="body1" style={{paddingLeft: '15px', paddingTop: '10px'}} className="lbl-main">
            {title}
          </Typography>
          <Grid xs={12}>
            <Divider style={{width: '100%', margin: '10px 0', color: '#2F3847'}} />
          </Grid>
        </React.Fragment>
      )}
      {items?.map(item => {
        const itemProps = {...defaultGridItemProps, ...item.props};
        return (
          !item.hidden && (
            <Grid item key={item.key} {...itemProps}>
              {item.element}
            </Grid>
          )
        );
      })}
    </Grid>
  );
};

export const FormRowGrid = ({rows}: {rows: GridRowProps[]}) => (
  <>
    {rows.map(({items, rowProps, title}) => (
      <React.Fragment key={rowProps?.key}>
        {!rowProps?.hidden && <GridRow items={items} rowProps={rowProps} title={title} />}
      </React.Fragment>
    ))}
  </>
);
